import axios from 'axios';
import co from 'co';
import AuthWrapper from './authwrapper.service';
import httpParamSerializer from './httpParamSerializer.js';
import config from '../core/common';



function OnlineApi() {
   const endpoint = config.endpoint;

   var sendEndPoint, queryEndPoint;

   init();

   return {
      send: send,
      query: query,
      getTaskExcelEligibility: getTaskExcelEligibility,
      downloadTaskExcel: downloadTaskExcel
   };

   function init() {
      sendEndPoint = endpoint + '/api/send';
      queryEndPoint = endpoint + '/api/query';
   }

   async function getTaskExcelEligibility(noTask) {
      try {
         const response = await query({ messageType: 'GET_TASK_EXCEL_ELIGIBILITY', noTask });
         return response.data;
      } catch (error) {
         if (error.response?.status === 401 || error.response?.status === 403) {
            throw new Error('You do not have permission to download this Task submission.');
         }
         if (error.response?.status === 422) {
            throw new Error(error.response.data?.content || error.response.data?.error || 'This Task does not have an eligible completed form submission.');
         }
         if (error.response?.status === 404 || error.response?.status === 400) {
            throw new Error('This Task does not have an eligible completed form submission.');
         }
         throw new Error('Unable to check Excel download eligibility.');
      }
   }

   async function downloadTaskExcel({ noTask, layout }) {
      try {
         const response = await axios({
            method: 'get',
            url: `${endpoint}/api/tasks/${encodeURIComponent(noTask)}/excel`,
            params: { layout },
            headers: await co(buildHeaders),
            responseType: 'blob'
         });
         const contentType = response.headers['content-type'] || '';
         if (!contentType.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
            throw new Error('The server did not return an Excel workbook.');
         }
         const disposition = response.headers['content-disposition'] || '';
         const match = /filename="(Task-\d+_Submission-\d+_(?:Flat|Structured)\.xlsx)"/.exec(disposition);
         if (!match) throw new Error('The server did not provide a valid Excel download filename.');
         const filename = match[1];
         const objectUrl = URL.createObjectURL(response.data);
         try {
            const anchor = document.createElement('a');
            anchor.href = objectUrl;
            anchor.download = filename;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
         } finally {
            setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
         }
      } catch (error) {
         if (error.response?.status === 401 || error.response?.status === 403) {
            throw new Error('You do not have permission to download this Task submission.');
         }
         if (error.response?.status === 422) {
            throw new Error('This Task does not have a valid completed form submission.');
         }
         if (error.response?.status === 404 || error.response?.status === 400) {
            throw new Error('This Task submission is not available for the selected Excel layout.');
         }
         throw error;
      }
   }

   function query(message) {
      var qs;

      message.mt = message.messageType;
      delete message.messageType;

      qs = httpParamSerializer(message);

      return new Promise(function (resolve, reject) {
         co(function* () {
            return yield axios({
               method: 'get',
               url: queryEndPoint + '?' + qs,
               headers: yield buildHeaders()
            });
         }).then(
            function (result) {
               AuthWrapper.setVersion(result.headers['X-Version']);
               resolve(result);
            },
            function (data) {
               reject(data);
            }
         );
      });
   }

   function send(message) {
      var qs;

      var marker = { mt: message.messageType };

      qs = httpParamSerializer(marker);

      return new Promise(function (resolve, reject) {
         co(function* () {
            return yield axios({
               method: 'post',
               url: sendEndPoint + '?' + qs,
               data: message,
               headers: yield buildHeaders()
            });
         }).then(
            function (result) {
               AuthWrapper.setVersion(result.headers['X-Version']);
               resolve(result);
            },
            function (data) {
               reject(data);
            }
         );
      });
   }

   function* buildHeaders() {
      var token = yield AuthWrapper.getToken();
      return {
         'X-Correlation-Id': AuthWrapper.getCorrelationId(),
         Authorization: 'Bearer ' + token
      };
   }
}

OnlineApi.instance = new OnlineApi();

export default OnlineApi.instance;
